import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMusicNote20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMusicNote20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.5 2.75A.75.75 0 0 1 7.25 2h10a.75.75 0 0 1 .75.75V15a3 3 0 1 1-1.5-2.599V6.528H8V15a3 3 0 1 1-1.5-2.599zM8 5.028h8.5V3.5H8zM6.5 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m10 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMusicNote20);
